// @ts-strict-ignore
import type { AggregationSourceData } from './types';
import type { AggregationOption } from './AggregationSelect';

// TODO: Update with follow-up tickets in OAK-1060 epic
// TODO: This needs to be dynamic based on the attributes
export const INITIAL_AGGREGATION_CONFIG: AggregationSourceData = {
  name: 'Entities',
  description: '',
  aggregation: 'count_distinct',
  subject: 'entities',
  scope: 'all',
  timeframeIntervalStart: 0,
  timeframeIntervalEnd: 90,
  timeframeUnit: 'days',
};

export const AGGREGATION_OPTIONS: AggregationOption[] = [
  { value: 'count_distinct', label: 'Distinct Count' },
  { value: 'avg', label: 'Average' },
  { value: 'count', label: 'Count' },
  { value: 'max', label: 'Max' },
  { value: 'min', label: 'Min' },
  { value: 'sum', label: 'Sum' },
];
export const SUBJECT_OPTIONS: AggregationOption[] = [{ value: 'entities', label: 'Entities' }];
export const SCOPE_OPTIONS: AggregationOption[] = [
  { value: 'entity', label: 'For the Entity being evaluated' },
  { value: 'group', label: 'For all Entities in this Group' },
  { value: 'all', label: 'Across all Entities' },
];
export const TIMEFRAME_UNIT_OPTIONS: AggregationOption[] = [
  { value: 'minutes', label: 'minutes' },
  { value: 'hours', label: 'hours' },
  { value: 'days', label: 'days' },
  { value: 'months', label: 'months' },
];
